module.exports = __webpack_public_path__ + "img/file-media.ed10f6ca.svg";